import {REQUEST_TRANSPORTER, REQUEST_TRANSPORTER_FAILURE, REQUEST_TRANSPORTER_SUCCESS} from "../../../constant/master/TransTransporterConstant";

const initialState = {
    transporter: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const transporterReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_TRANSPORTER:
            return {
                ...state,
                transporter: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_TRANSPORTER_SUCCESS:
            return {
                ...state,
                transporter: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_TRANSPORTER_FAILURE:
            return {
                ...state,
                transporter: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
